module.exports = __webpack_public_path__ + "img/check.a7adbce9.svg";